// Parses the string 'true'/'false' into an actual boolean, leaving any other
// value untouched (matches the previous String.prototype.toBoolean behavior).
const toBoolean = (value) => {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return value;
};

export default toBoolean;
